import { rem, Slider, SliderProps } from '@mantine/core';

export function SimpleSlider(props: SliderProps) {
  return (
    <Slider
      color='teal.5'
      defaultValue={40}
      thumbSize={20}
      styles={{
        thumb: {
          borderWidth: 0,
          padding: rem(3),
          backgroundColor: 'black',
        },
        track: {
          backgroundColor: 'gray.0',
        },
      }}
      {...props}
    />
  );
}
